import { Component, Inject, forwardRef } from '@angular/core';
import { smoothlyMenu } from '../../app.helpers';
import { AppComponent } from 'app/app.component';
declare var jQuery: any;

@Component({
    selector: 'topnavbar',
    templateUrl: 'topnavbar.template.html',
    standalone: false
})
export class TopNavbarComponent {
    constructor(@Inject(forwardRef(() => AppComponent)) public app: AppComponent) {}

    toggleNavigation(): void {
        jQuery('body').toggleClass('mini-navbar');
        smoothlyMenu();
    }
}
